import { render } from "./ExpandableProjectImage.vue?vue&type=template&id=c59744d2&scoped=true"
import script from "./ExpandableProjectImage.vue?vue&type=script&lang=js"
export * from "./ExpandableProjectImage.vue?vue&type=script&lang=js"

import "./ExpandableProjectImage.vue?vue&type=style&index=0&id=c59744d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59744d2"]])

export default __exports__